import { TireConditionType } from '../../../constants/product/product.constant';
import { tractorImageType } from '../../../store/userSellTractorSurveySlice';
import { customAxios } from '../../common/customAxios';

export interface ITractorImage {
  type: tractorImageType;
  url: string;
}

interface postUsersSellTractorsParams {
  reqBody: {
    brandId: string;
    userOwnTractorId: string | null;
    model: string;
    engineOutputInPs: number;
    manufacturedYear: number;
    operationTime: number;
    option: string | null;
    optionDetails: string[] | null;
    workingMachine: string | null;
    workingMachineDetails: string[] | null;
    hopeSellingPrice: number;
    tractorImages: ITractorImage[];
    location: string;
    directImportYn: boolean | null;
    priceNegotiationYn: boolean | null;
    frontTireCondition: TireConditionType | null;
    rearTireCondition: TireConditionType | null;
    needRepairParts: string[] | null;
    replacedParts: string[] | null;
    information: string;
  };
}

export const postUsersSellTractors = ({ reqBody }: postUsersSellTractorsParams): Promise<void> => {
  return customAxios.post('/user-sell-tractors', reqBody);
};
